// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2086": "3dd61ce8","4079": "cd95f0d2","4479": "360157a5","6246": "c38d4a2e","6489": "688e6f00","7348": "c2bbdf9f","9998": "319e9bbe",}[chunkId] + ".css"
}